import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { doDeletePromise, doGetPromise } from '../config/core.httpclient-utils';

@Injectable()
export class SnapshotService {

  private baseUrl = '/api/snapshot';

  constructor(private http: HttpClient) { }

  listAll(params: any = {}) {
    return doGetPromise(this.http, this.baseUrl, params);
  }

  delete(id: string) {
    return doDeletePromise(this.http, `${this.baseUrl}/${id}`);
  }

  download(id: string) {
    return doGetPromise(this.http, `${this.baseUrl}/${id}/download`, { responseType: 'blob' });
  }

  postImport(id: string, unixName: string) {
    return this.http.post(`${this.baseUrl}/${id}/import/${unixName}`, {}).toPromise();
  }

  hasRequest(unixName: string) {
    return doGetPromise(this.http, `${this.baseUrl}/${unixName}/request`);
  }

  submitRequest(unixName: string, params: any = {}) {
    return this.http.post(`${this.baseUrl}/${unixName}/request`, params).toPromise();
  }

  deleteRequest(unixName: string) {
    return doDeletePromise(this.http, `${this.baseUrl}/${unixName}/request`);
  }
}